import React from 'react';

export default function H1({...rest}){
  return (
    <h1 {...rest}></h1>
  )
}